export default __webpack_public_path__ + "static/media/html5.323dab0c.png";